import type { GeoJsonFeature, GeoJsonPosition } from "../../core/types/geojson";

export class CoordinateExtractor {
  static createPointFeature(lat: number, lng: number, properties: Record<string, unknown> = {}): GeoJsonFeature {
    if (!Number.isFinite(lat) || !Number.isFinite(lng)) throw new Error("Latitude and longitude must be valid numbers.");
    return {
      type: "Feature",
      properties,
      geometry: { type: "Point", coordinates: [lng, lat] }
    };
  }

  static parseLngLatLines(input: string): GeoJsonPosition[] {
    return input
      .split(/\r?\n/)
      .map((line) => line.trim())
      .filter(Boolean)
      .map((line) => {
        const [lngRaw, latRaw] = line.split(/[\s,]+/);
        const lng = Number(lngRaw);
        const lat = Number(latRaw);
        if (!Number.isFinite(lng) || !Number.isFinite(lat)) throw new Error(`Invalid coordinate line: ${line}`);
        return [lng, lat] as GeoJsonPosition;
      });
  }

  static formatLatLngPairs(points: GeoJsonPosition[]): string {
    return points.map(([lng, lat]) => `{ lat: ${lat}, lng: ${lng} }`).join(",\n");
  }

  static formatGoogleLatLngPairs(points: GeoJsonPosition[]): string {
    return this.formatLatLngPairs(points);
  }
}
